import { ActorType } from "@common/types/auditLog";
import { FilterTabs } from "../../pageHeader/filters/lib";

export interface FinancialDocumentFilters {
    search?: string;
    start?: Date;
    end?: Date;
    isImported?: boolean;
    isImporting?: boolean;
    isNotImported?: boolean;
    isDocReconciled?: boolean;
    isDocReconciling?: boolean;
    isDocNotReconciled?: boolean;
    isDocMatched?: boolean;
    isDocNotMatched?: boolean;
    entityIds?: number[];
    hasNoEntity?: boolean;
    periodStart?: string;
    periodEnd?: string;
    documentCategoryIds?: string[];
    uploaderIds?: Array<number | null>;
    uploaderType?: ActorType;
    uploaderSources?: string[];
    accountIds?: number[];
    hasNoFinancialAccount?: boolean;
    counterpartiesIds?: string[];
    hasNoCounterparty?: boolean;
    withEmptyOrUnverifiedCounterparty?: boolean;
    fileExtensions?: string[];
    financialDocumentIds?: number[];
}

const BASE_DOCUMENT_FILTERS: FilterTabs[] = [
    FilterTabs.UPLOAD_DATE,
    FilterTabs.DOCUMENT_STATUS,
    FilterTabs.ACCOUNT,
    FilterTabs.DOCUMENT_TYPE,
    FilterTabs.UPLOADER,
    FilterTabs.COUNTERPARTY,
];

const CATEGORY_DOCUMENT_FILTERS: FilterTabs[] = [
    FilterTabs.DOCUMENT_CATEGORY,
    FilterTabs.DOCUMENT_PERIOD,
];

export function getDocumentFilters(): FilterTabs[] {
    return [...BASE_DOCUMENT_FILTERS, ...CATEGORY_DOCUMENT_FILTERS];
}
